import React from "react";
import { Link } from "react-router-dom";
import { Paths } from "./../constants/UrlConstants";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const MakeAClaim = {
  pageTitle: "make a claim",
  bannerText:
    "Let's get started with your claim. First, please select the type of claim you need to make and we'll guide you through the process.",
  bannerTextNoChoice:
    "Let's get started with your claim.",
  startClaim:"Start Claim",
  nonSelectionError:"Select a claim type to continue",
  addBank:"Add your bank details for direct settlement",
  addBankAccount: (
    <React.Fragment>
      Add your Bank account{ " "}
      <Link
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        to={Paths.ChangeBankDetails}
      >
       {" "} Click Here to update bank details
      </Link>
      .
    </React.Fragment>
  ),
  helpText: {
    International: (
      <React.Fragment>
        For more contact options, please go to your{" "}
        <Link
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          to={Paths.Inbox}
        >
          inbox
        </Link>
        .
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        Need some help?{" "}
        <Link
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          to={Paths.HowToClaim}
        >
          Find out how to make a claim
        </Link>
        .
      </React.Fragment>
    )
  }
};

export default MakeAClaim;
